import SectionPromotion from './SectionPromotion'

export default SectionPromotion
// eslint-disable-next-line import/export
export * from './SectionPromotion'
